import { configureStore } from "@reduxjs/toolkit";
import UISlice from "./ui-slice";
import userSlice from "./user-store/user-slice";
import authSlice from "./auth-store/auth-slice";
import chargeSlice from "./charge-store/charge-slice";
import departmentSlice from "./department-store/department-slice";
import countrySlice from "./country-store/country-slice";
import organizationSlice from "./organization-store/organization-slice";
import documenttypeSlice from "./documenttype-store/documenttype-slice";
import permissionSlice from "./permission-store/permission-slice";
import userpermissionSlice from "./userpermission-store/userpermission-slice";
import statusSlice from "./status-store/status-slice";
import signSlice from "./sign-store/sign-slice";

const store = configureStore({
  reducer: {
    ui: UISlice.reducer,
    user: userSlice.reducer,
    auth: authSlice.reducer,
    charge: chargeSlice.reducer,
    department: departmentSlice.reducer,
    country: countrySlice.reducer,
    organization: organizationSlice.reducer,
    documenttype: documenttypeSlice.reducer,
    permission: permissionSlice.reducer,
    userpermission: userpermissionSlice.reducer,
    status: statusSlice.reducer,
    sign: signSlice.reducer,
  },
});

export default store;
